<template>
  <div class="container">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" :disabled="!selectShip.length" @click="onPrint()" v-if="funcView.contract_ship_print">{{ funcView.contract_ship_print }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.contract_ship_pending_export" style="float: right; margin-right: 0">
          <el-button class="table-set" @click.native="exportTable('shipPlanExport', { ...formSearch })">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_pending.he_tong_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_pending.ji_hua_fa_huo_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.planDeliveryTimer" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_pending.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :tableCode="tableCode"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        type="checkbox"
        v-model="selectShip"
        :slots="['customShipmentNum', 'action']"
      >
        <template v-slot:customShipmentNum="scope">
          <div class="cell-link" @click="onDetails(scope.row)">{{ scope.row.customShipmentNum }}</div>
        </template>
        <!-- 操作 -->
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="onShip(scope.row)" v-if="funcView.contract_ship_shipped">{{ funcView.contract_ship_shipped }}</el-button>
          <!-- <el-button type="text" size="mini" @click="onPrint(scope.row)" v-if="funcView.contract_ship_print">{{ funcView.contract_ship_print }}</el-button> -->
          <el-button type="text" size="mini" @click="onEdit(scope.row)" v-if="funcView.contract_ship_edit">{{ funcView.contract_ship_edit }}</el-button>
          <el-button type="text" size="mini" @click="onDelete(scope.row)" v-if="funcView.contract_ship_delete">{{ funcView.contract_ship_delete }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <div class="num-info">
        <div class="item">
          {{ $t('crm_pending.dai_fa_huo_shu_liang') }}:
          <span class="sum">{{ total }}</span>
        </div>
      </div>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 新增编辑 -->
    <ship-item-dialog v-if="dialogVisible" @close="dialogVisible = false" :model="dialogModel" @success="getTableList"></ship-item-dialog>
    <!-- 查看发货单 -->
    <ship-itemDetail-dialog v-if="dialogVisible1" @close="dialogVisible1 = false" :model="dialogModel1"></ship-itemDetail-dialog>
    <!--发货-->
    <factory-send-plan v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></factory-send-plan>
    <!-- 打印发货单 -->
    <contract-download v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false"></contract-download>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import contractDownload from '@/pages/crm/components/contractDownload.vue';
import factorySendPlan from '@/pages/crm/contractHandle/factory_send_plan.vue';
import shipItemDialog from '@/pages/crm/components/ship_item_dialog.vue';
import shipItemDetailDialog from '@/pages/crm/components/ship_itemDetail_dialog.vue';

export default {
  name: 'pending',
  mixins: [resetFormSearchMixins],
  components: {
    shipItemDialog,
    shipItemDetailDialog,
    factorySendPlan,
    contractDownload,
  },
  props: {},
  data() {
    return {
      tableCode: 'ship_pending',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        search: '',
        planDeliveryTimer: [],
        planStartTime: '',
        planEndTime: '',
        productCode: '',
        dataType: 1,
      },
      tableList: [],
      totalRows: null,
      total: undefined,
      selectShip: [],
      // 添加编辑发货计划
      dialogVisible: false,
      dialogModel: {},
      // 查看发货详情
      dialogVisible1: false,
      dialogModel1: {},
      // 发货
      dialogVisible2: false,
      dialogModel2: {},
      //  下载合同
      dialogVisible4: false,
      dialogModel4: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onEdit(row) {
      this.dialogModel = {
        title: this.$t('crm_pending.bjfhjh'),
        type: 'edit',
        data: row,
      };
      this.dialogVisible = true;
    },

    // 发货
    onShip(row) {
      this.dialogModel2 = {
        title: this.$t('crm_pending.fa_huo'),
        detail: row,
        data: row,
        orderClass: row.orderClass,
      };
      this.dialogVisible2 = true;
    },
    onDetails(row) {
      this.dialogModel1 = {
        title: this.$t('crm_pending.cha_kan_fa_huo_dan'),
        type: 'pending',
        data: row,
      };
      this.dialogVisible1 = true;
    },
    // 打印发货单
    onPrint() {
      const orderDeliveryIds = this.selectShip.map(item => item.orderDeliveryId).join(',');
      this.dialogVisible4 = true;
      this.dialogModel4 = {
        title: this.$t('crm_pending.da_yin_fa_huo_dan'),
        data: {
          // 823921301846863879,825090743624642560
          // orderDeliveryId: '823921301846863879,825090743624642560'
          orderDeliveryId: orderDeliveryIds,
        },
      };
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
      this.getTableListTotal();
    },
    getTableList() {
      this.formSearch.planStartTime = this.formSearch.planDeliveryTimer && this.formSearch.planDeliveryTimer[0] ? this.formSearch.planDeliveryTimer[0] : undefined;
      this.formSearch.planEndTime = this.formSearch.planDeliveryTimer && this.formSearch.planDeliveryTimer[1] ? this.formSearch.planDeliveryTimer[1] : undefined;
      this.$getJSON(apis.shipPlanPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getTableListTotal() {
      this.$getJSON(apis.shipPlanDeviceTotal, this.formSearch).then((res) => {
        this.total = res.data ? res.data.deviceNum : 0;
      });
    },
    onDelete(row) {
      const tips = this.$t('crm_pending.nqdyscdqxzdfhjhm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.shipPlanDelete}/${row.orderDeliveryId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete'),
            type: 'success',
          });
          this.onPageChange({ page: 1 });
        });
      });
    },
  },
  created() {},
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();
    this.getTableList();
    this.getTableListTotal();

  },
};
</script>

<style lang="scss" scoped>
.container {
  flex: 1;
  display: flex;
  padding-left: 16px;
  flex-direction: column;
  overflow: hidden;
}
</style>
